import { useEffect, useState } from "react"
import { Box, useColorMode } from "@chakra-ui/react"
import { JsonViewer } from "@textea/json-viewer"

import { GridItem } from "@/components"

const ResponseDetail = ({ response, ...rest }) => {
    const { colorMode } = useColorMode()
    const [body, setBody] = useState()

    useEffect(() => {
        const getResponseBody = async () => {
            if (!response) {
                setBody("Empty")
            } else {
                setBody(response.body)
            }
        }

        getResponseBody().catch(console.error)
    }, [response])

    return (
        <GridItem {...rest}>
            <Box maxH="100%" overflow="auto">
                <JsonViewer
                    theme={colorMode}
                    indentWidth={2}
                    value={body}
                    displayObjectSize={false}
                    displayDataTypes={false}
                    enableClipboard={false}
                    rootName={false}
                    style={{ background: "transparent" }}
                />
            </Box>
        </GridItem>
    )
}

export { ResponseDetail }
